import React from "react";
import heroVideo from "../../images/hero-video.mp4";
import Header7 from "../Header/Header7";
import SimpleSlider2 from "../Sliders/Slick-slider2";
import bg_vide from "../../videos/hero-video2.mp4";
import Footer2 from "../Footer/Footer5";
function A4HFIRST() {
  return (
    <>
      <style>{`
        body, html {
    margin: 0;
    padding: 0;
  }

  .hero-image { 
    position: relative; 
    width: 100%; 
    height: 100vh; 
    overflow: hidden; 
    line-height: 0;
  }

  .hero-image video { 
    width: 100%; 
    height: 100%; 
    object-fit: contain; 
    display: block; 
  }

  .hero-header {
    text-align: center;
    padding: 40px 20px;
    background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
    color: #e91f1f;
  }

  .hero-header h1{
    margin: 0;
    margin-bottom: 50px;
    font-size: 32px;
    font-weight: 900;
    letter-spacing: 1px;
  }

  .hero-header p{
  max-width: 1300px;
  margin: 25px auto;
  font-size: 18px;
  line-height: 1.9;
  color: #222;
  font-weight: 500;
  text-align: justify;
  padding: 0 40px;
  box-sizing: border-box;
}
.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
  @media (max-width: 768px) {

  .hero-header {
    padding: 30px 15px;
  }

  .hero-header h1{
    font-size: 18px;
    line-height: 1.2;
  }

  .hero-header h4{
    font-size: 14px;
    line-height: 1.25;
  }

  .hero-header p{
    font-size: 13px !important;
    line-height: 1.4;
    padding: 0 10px;
    text-align: left;
  }

  .section-divider span{
    font-size: 16px;
  }
}
      `}</style>


      <div  id="home" className="full-screen-block viewport-video-page"> 
        <video
          autoPlay
          loop
          muted
          playsInline
          disablePictureInPicture
          disableRemotePlayback
          className="bg_video"
          onContextMenu={(e) => e.preventDefault()}
        >
                <source src={bg_vide} type="video/mp4"></source>
        </video> 
        
        <Header7/>
        <SimpleSlider2/>
      </div>

      {/* HEADER BELOW VIDEO */}
      <div className="hero-header">
        <h1>FESTIVAL OF GLOBE -  NON PROFIT ORGANIZATION - 501(c)(3)</h1>
        <div className="section-divider">
            <span>✦ ✦ ✦</span>
          </div> 
          <h4>
            <strong>
              Celebrating Heritage, Building Community, and Connecting Cultures
            </strong>
          </h4>
        <p>
          Festival of Globe (FOG) is a premier cultural and community-based nonprofit organization dedicated to celebrating diversity, promoting cultural understanding, and bringing communities together through education, service, and public engagement. Through its signature festivals, community programs, cultural initiatives, charitable activities, and the internationally recognized India Day Parade and Fair, FOG has become a leading platform for preserving heritage while fostering unity and mutual respect among people of all backgrounds.
        </p>
        <p>
          For decades, FOG has served as a bridge connecting cultures, generations, and communities. In an increasingly interconnected world, the preservation of cultural identity and the promotion of cross-cultural understanding have never been more important. FOG exists to ensure that traditions, values, arts, and heritage continue to thrive while creating opportunities for people from diverse backgrounds to learn from one another and celebrate the richness of global cultures.
        </p>
        <p>
          Through year-round programs, community services, cultural festivals, educational initiatives, public recognitions, and large-scale community celebrations, FOG inspires civic pride, volunteerism, and cultural appreciation. By creating meaningful experiences that unite people across backgrounds and generations, Festival of Globe continues to strengthen communities, celebrate diversity, and build a more connected and harmonious society.
        </p>
      </div>
      <Footer2/>
    </>
  );
}

export default A4HFIRST;
